<template>
  <div>
    <div class="yazdirtable">
      <div v-for="d in data" v-if="d.Ekstre">
        <h1>[{{ d.Bilgi.Kat }} Kat {{ d.Bilgi.kNo }} No] {{ d.Bilgi.AdSoyad }} Kişi Borç Dökümü</h1>
        <table class="table table-bordered">
          <thead>
          <tr>
            <th>T.Tarihi</th>
            <th>S.Ö.Tarihi</th>
            <th>Kategori</th>
            <th>Açıklama</th>
            <th>Zam Bilgi</th>
            <th class="text-right">Tutar</th>
            <th class="text-right">Zam</th>
            <th class="text-right">Ödenecek</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="e in d.Ekstre">
            <td>{{ e.tTarihi }}</td>
            <td>{{ e.sTarihi }}</td>
            <td>{{ e.Kategori }}</td>
            <td>{{ e.Aciklama }}</td>
            <td>{{ e.zBilgi }}</td>
            <td class="text-right">{{ e.Tutar }}</td>
            <td class="text-right">{{ e.Zam }}</td>
            <td class="text-right">{{ e.Toplam }}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <td colspan="5"></td>
            <td class="text-right">{{ d.AltToplam.Tutar }}</td>
            <td class="text-right">{{ d.AltToplam.Zam }}</td>
            <td class="text-right">{{ d.AltToplam.Toplam }}</td>
          </tr>
          </tfoot>
        </table>
        <div class="sayfasonu"></div>
      </div>
    </div>
    <el-tabs type="border-card" class="tab-p0 yazdirma">
      <el-tab-pane v-for="d in data" :lazy=true v-if="d.Ekstre">
        <span slot="label">[{{ d.Bilgi.Kat }} Kat {{ d.Bilgi.kNo }} No] {{ d.Bilgi.AdSoyad }}</span>
        <RaporlamaKisiEkstre :data="d"></RaporlamaKisiEkstre>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import RaporlamaKisiEkstre from "../../../components/Pack/Raporlama/RaporlamaKisiBorcEkstre";
export default {
  props:['data'],
  components: {RaporlamaKisiEkstre}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Raporlama/kisi/KisiBorcEkstre.vue